import { Box, View } from "components/ui";
import React, { ComponentProps } from "react";
import Animated, { FadeIn, FadeOut, LinearTransition } from "react-native-reanimated";

const FadeHandler = (props: ComponentProps<typeof View>) => {
	return (
		<Box {...props}>
			<Animated.View layout={LinearTransition.duration(2000).delay(200)} key={Math.random() + Math.random()} entering={FadeIn} exiting={FadeOut}>
				{props.children}
			</Animated.View>
		</Box>
	);
};

export default FadeHandler;
